<template>
  <div class="login-page" data-test="login__page">
    <Card classNames="login-card">
      <div class="login-card__header">
        <span class="login-title">{{ $t('authPage.title') }}</span>
        <HSpacer size="s"/>
        <AuthForm @onLogin="onLogin"/>
      </div>
    </Card>
  </div>
</template>

<script>
  import HSpacer from '@/components/Divider/HSpacer.vue';
  import Card from '../../../components/Card/Card.vue';
  import AuthForm from './AuthForm/AuthForm.vue';

  export default {
    components: {
      Card,
      HSpacer,
      AuthForm,
    },
    methods: {
      onLogin() {
        console.log('done');
      },
    },
  };
</script>

<style lang="stylus">
  .login-page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .login-card {
    width: 450px;
    padding: 40px 32px;
  }

  .login-card__header {
    text-align: center;
  }

  .login-title {
    color: $primary-color;
    position: relative;
    font-size: 2.3em;
    font-weight: 600;
    text-align: center;
    display: inline;
  }
</style>
